import {
    Link
    //, useNavigate
} from 'react-router-dom';

const RealSplitNewsList = () => {
    return (

        <div
            style={{
                height: '100%'
                //, border: 'green 2px solid'
            }}
            >
        <h1
            style = {{
                fontFamily: 'Baskervville'
                //color: 'var(--color-gray-700)'
                //color: 'white'
                //, textAlign: 'center'
                //, border: 'black 2px solid'
                , paddingBottom: '50px'
            }}>
            RealSplit™ News
        </h1>

        <div
            //className = "about-section about-how-it-works"
            className = "about-section"
            style = {{
                height: '100%'
                , display: 'flex'
                , alignItems: 'center'
                , justifyContent: 'center'
                , marginTop: 0
                , marginBottom: 'auto'
                , verticalAlign: 'top'
                , paddingTop: '100px'
                , paddingBottom: '100px'
                //, border: 'red 2px solid'
            }}
            >

            {/*
            <div
                className = 'about-section-circle-wrapper'
                //style = {{
                //    textAlign: 'center'
                //    , margin: 'auto'
                //    , marginTop: '-65px'
                //}}
                >
                <div className = 'about-section-circle'>
                    <img
                        className = 'svg'
                        //src = 'images/icons/work-started-icon.svg'
                        //src = 'https://img.icons8.com/sf-black-filled/64/FFFFFF/administrative-tools.png'
                        src = 'images/icons/factory-svgrepo-com.svg'
                        />
                </div>
            </div>
            */}

            <div
                className = "about-content"
                style = {{
                    //borderLeft: 'var(--color-theme-primary) 2px solid'
                    height: '100%'
                    , display: 'flex'
                    , alignItems: 'center'
                    , justifyContent: 'center'
                    //, border: 'orange 2px solid'
                }}
                >
                <div
                    //style = {{ borderLeft: 'var(--color-theme-primary) 5px solid', borderTopLeftRadius: '5px' }}
                    >
                    <Link
                        to = '/news/RealSplitLaunches'
                        style = {{ color: '#075BC5' }}
                        >
                        <strong>Sugar Land, TX, May 07, 2025</strong> --(PR.com)-- RealSplit Technology Group. RealSplit™ Launches Fractional Real Estate Platform with Three Blue-Chip Properties
                    </Link>
                </div>
            </div>
        </div>

        </div>
    );
};
  
export default RealSplitNewsList;